import { c as _c } from "react/compiler-runtime";
import type { GrantDetails } from "../types";
import { GrantDetailsRow } from "./GrantDetailsRow";
export function GrantDetailsGrid(t0) {
  const $ = _c(28);
  const {
    details
  } = t0;
  let t1;
  if ($[0] !== details.tokenTypeLabel) {
    t1 = <GrantDetailsRow label="Token type" value={details.tokenTypeLabel} />;
    $[0] = details.tokenTypeLabel;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  if ($[2] !== details.totalSupplyLabel) {
    t2 = <GrantDetailsRow label="Total supply" value={details.totalSupplyLabel} />;
    $[2] = details.totalSupplyLabel;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  let t3;
  if ($[4] !== details.floorPriceLabel) {
    t3 = <GrantDetailsRow label="Floor price" value={details.floorPriceLabel} />;
    $[4] = details.floorPriceLabel;
    $[5] = t3;
  } else {
    t3 = $[5];
  }
  let t4;
  if ($[6] !== details.tokensCountLabel) {
    t4 = <GrantDetailsRow label="Tokens granted" value={details.tokensCountLabel} />;
    $[6] = details.tokensCountLabel;
    $[7] = t4;
  } else {
    t4 = $[7];
  }
  let t5;
  if ($[8] !== details.tdhRateLabel) {
    t5 = <span>{details.tdhRateLabel}</span>;
    $[8] = details.tdhRateLabel;
    $[9] = t5;
  } else {
    t5 = $[9];
  }
  let t6;
  if ($[10] !== details.tdhRatePerTokenHint || $[11] !== details.tdhRatePerTokenLabel) {
    t6 = details.tdhRatePerTokenLabel ? <span className="tw-text-xs tw-font-semibold tw-text-iron-400 tw-whitespace-nowrap" title={details.tdhRatePerTokenHint ?? undefined}>({details.tdhRatePerTokenLabel}/token)</span> : null;
    $[10] = details.tdhRatePerTokenHint;
    $[11] = details.tdhRatePerTokenLabel;
    $[12] = t6;
  } else {
    t6 = $[12];
  }
  let t7;
  if ($[13] !== t5 || $[14] !== t6) {
    t7 = <GrantDetailsRow label="TDH rate" value={<div className="tw-flex tw-items-baseline tw-gap-2 tw-text-sm tw-font-medium tw-text-iron-100">{t5}{t6}</div>} />;
    $[13] = t5;
    $[14] = t6;
    $[15] = t7;
  } else {
    t7 = $[15];
  }
  let t8;
  if ($[16] !== details.totalGrantedLabel) {
    t8 = <GrantDetailsRow label="Total granted" value={details.totalGrantedLabel} />;
    $[16] = details.totalGrantedLabel;
    $[17] = t8;
  } else {
    t8 = $[17];
  }
  let t9;
  if ($[18] !== details.validFromLabel) {
    t9 = <GrantDetailsRow label="Valid from" value={details.validFromLabel} />;
    $[18] = details.validFromLabel;
    $[19] = t9;
  } else {
    t9 = $[19];
  }
  let t10;
  if ($[20] !== t1 || $[21] !== t2 || $[22] !== t3 || $[23] !== t4 || $[24] !== t7 || $[25] !== t8 || $[26] !== t9) {
    t10 = <dl className="tw-grid tw-gap-3 sm:tw-grid-cols-2 lg:tw-grid-cols-3 md:tw-ml-20">{t1}{t2}{t3}{t4}{t7}{t8}{t9}</dl>;
    $[20] = t1;
    $[21] = t2;
    $[22] = t3;
    $[23] = t4;
    $[24] = t7;
    $[25] = t8;
    $[26] = t9;
    $[27] = t10;
  } else {
    t10 = $[27];
  }
  return t10;
}